<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-address-book"/> {{caption}}
        <div class="card-header-actions">
          <CButton color="info" size="sm" @click="storeModal()">Nuevo Proveedor</CButton>
          <CButton color="success" size="sm" @click="getExcel()">Excel</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 10 : 5"
        :dark="dark"
        pagination
      >
        <template #phone="{item}"><td class="w200 text-center">{{item.phone}}</td></template>
        <template #mobile="{item}"><td class="w200 text-center">{{item.mobile}}</td></template>
        <template #actions="{item}">
          <td class="table_actions b2">
            <CButton color="warning" size="sm" @click="updateModal(item)"><CIcon name="cil-pencil"/></CButton>
            <CButton color="danger" size="sm" @click="deleteModal(item)"><CIcon name="cil-trash"/></CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <SupplierModal ref="supplierModal" @store="storeProcess" @update="updateProcess"></SupplierModal>
    <DeleteModal ref="deleteModal" @delete="deleteProcess"></DeleteModal>
  </CCard>
</template>

<script>
import SupplierModal from './SupplierModal.vue'
import DeleteModal from '../global/DeleteModal.vue'
import ws from '../../services/suppliers';
import store from '../../store'

export default {
  name: 'SuppliersTable',
  components: { SupplierModal, DeleteModal },
  props: {
    items: Array,
    fields: {
      type: Array,
      default () {
        return [
          {key: 'name', label: 'Nombre'},
          {key: 'email', label: 'Correo Electrónico'},
          {key: 'phone', label: 'Teléfono'},
          {key: 'mobile', label: 'Celular'},
          {key: 'actions', label: 'Acciones', class: 'actions' },
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      toasts: []
    }
  },
  methods: {
    storeModal () {
      this.$refs.supplierModal.storeModal();
    },
    updateModal (item) {
      this.$refs.supplierModal.updateModal(item);
    },
    deleteModal (item) {
      this.$refs.deleteModal.show("Eliminar Proveedor", item.id, item.name);
    },
    async storeProcess(data) {
      let response = await ws.store(data);
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async updateProcess(data) {
      let response = await ws.update(data);

      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async deleteProcess(id) {
      let response = await ws.delete({id: id});
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async getExcel() {
      let response = await ws.excel();
      
      if(response.type == "success"){
        window.location = response.data;
      }

      this.showToast(response.type, response.message);
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
